class MyraVideoHero extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.events = new AbortController();
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updatePlayback = () => {
      if (motion.matches) this.video.pause();
      else this.video.play().catch(() => {
        // Keep the poster visible when the browser blocks autoplay.
      });
    };
    motion.addEventListener('change', updatePlayback, { signal: this.events.signal });
    updatePlayback();
  }

  disconnectedCallback() {
    this.events?.abort();
    this.video?.pause();
  }
}

if (!customElements.get('myra-video-hero')) {
  customElements.define('myra-video-hero', MyraVideoHero);
}
